import Http from '../../shared/http'

/*
 * Do the ajax call that will save or implement the
 * current scenario.
 * @param options: Named param objects to contain special params when
 * saving or implementing a retirement scenario
 * Options:
 *  - implement: Boolean if a plan should be implemented or not
 *  - consent_given: Boolean whether or not consent was given for a change in
 *    risk profile
 */
export const submitSaveRetirementScenarioForm = async (props, options) => {
  const { implement, status, consent_given, consent_cellphone_number } = options
  const { scenarioName, sendImplementationNoticeToClient, notes, advisorDeclarationAcceptance, usePresentValue } = props
  const params = {
    implement,
    send_implement_notification: sendImplementationNoticeToClient,
    advisor_declaration_acceptance: advisorDeclarationAcceptance,
    use_present_value: usePresentValue,
    retirement_scenario: {
      name: scenarioName,
      risk_profile: {
        consent_given,
        consent_cellphone_number
      },
      status,
      notes: notes || []
    }
  }

  props.setSavingInprogress(true)
  // The server handles failure here with a toast. This possibly needs
  // to be moved to the front.
  await Http.request(props.url, props.method, JSON.stringify(params))
    .then(async (response) => {
      const body = await response.json()
      window.location.href = body.location
    })
}

export const confirmWithOtpClick = async (props) => {
  props.setSavingInprogress(true)

  await Http.request(props.requestOtpUrl, 'POST')
    .then(async (response) => {
      if (response.ok) {
        const body = await response.json()
        props.setOtp(body.otp_code)
        props.setConfirmRiskChanges(true)
      }
    })
}

export const saveWithOTPClick = async (props) => {
  const otpParams = {
    two_factor_auth_sessions: {
      one_time_pin: props.Otp
    }
  }
  const { clientCellphoneNumber } = props

  await Http.request(props.verifyOtpUrl, 'POST', JSON.stringify(otpParams))
    .then((response) => {
      if (response.ok) {
        submitSaveRetirementScenarioForm(props, { implement: true, consent_given: true, consent_cellphone_number: clientCellphoneNumber })
      } else {
        props.setErrorMessage('The OTP is either incorrect or expired. Re-enter the OTP to try again, or click resend OTP to get a new code.')
        props.setSavingInprogress(false)
      }
    })
}

export const resendOTPClick = async (props) => {
  await Http.request(props.resendOtpUrl, 'POST')
    .then((response) => {
      if (!response.ok) {
        props.setErrorMessage('We\'re having some trouble re-sending the OTP. Please check your internet connected and try again')
      }
    })
}
